import {
  Component, Input, Output, EventEmitter, ChangeDetectorRef, HostListener
} from '@angular/core';
import { formService } from '../Service/formService';
import { Token } from '../Models/Token';
import { ePayService } from "../Service/ePayService";
import { DomSanitizer } from '@angular/platform-browser';
import { each } from 'lodash-es';
import { Session_Credit_Card_RequestModel } from '../Models/Model/Session_Credit_Card_RequestModel';
import { CardConectComponent } from './CardConnect/cardconnect.component'
import { SnapPayComponent } from './SnapPay/snappay.component'

@Component({
  selector: 'credit-card',
  templateUrl: 'creditcard.component.html',
  styleUrls: ['creditcard.component.css'],
  providers: [CardConectComponent, SnapPayComponent],
  imports: [CardConectComponent, SnapPayComponent],
  exportAs: 'ngModel'
})
export class CreditCardComponent {
  private token: Token = new Token();
  //public validCard: boolean = false;
  //public valid: boolean = false;
  //public invalid: boolean;
  //public isCardValid: boolean;
  //private iframeUrl;

  ////Listed card connect for the cc token
  //@HostListener('window:message', ['$event'])
  //onMessage(e) {
  //  if (this.ePayService) {
  //    if (e) {
  //      if (e.origin != this.ePayService.Origin()) {
  //        return false;
  //      }
  //      else {
  //        if (e.data) {
  //          try {
  //            this.carddata = <Token>JSON.parse(e.data);
  //          }
  //          catch
  //          {
  //          }
  //        }
  //      }
  //    }
  //  }
  //}

  //get/set the card data
  @Input() get carddata(): Token {
    return this.token;
  }
  set carddata(value: Token) {
    this.token = value;
    this.carddataChange.emit(this.token);
  }

  @Output() carddataChange: EventEmitter<Token> = new EventEmitter();

  IsCardConnect = () => {
    var results = false;
    if (this.ePayService) {
      each(this.ePayService.ePay?.paymentPage.credit_card, (credit_card: Session_Credit_Card_RequestModel) => {
        if (credit_card.cardconnect) {
          results = true;
        }
      });
    }
    return results;
  }

  IsSnapPay = () => {
    var results = false;
    if (this.ePayService) {
      each(this.ePayService.ePay?.paymentPage.credit_card, (credit_card: Session_Credit_Card_RequestModel) => {
        if (credit_card.snappay) {
          results = true;
        }
      });
    }
    return results;
  }

  ////Get the iframe
  //get iframeURL() {
  //  return this.iframeUrl;
  //}

  ////Validate the card token
  //ngAfterViewChecked() {
  //  this.valid = false;
  //  if (this.carddata) {
  //    if (this.carddata.validationError !== undefined) {
  //      this.valid = false;
  //    }
  //    else {
  //      if (this.carddata.message !== undefined && this.carddata.expiry !== undefined) {
  //        if (this.carddata.message && this.carddata.expiry) {
  //          this.valid = true;
  //        }
  //      }
  //    }
  //  }
  //  this.carddata.valid = this.valid;
  //  this.invalid = !this.valid;

  //  this.carddataChange.emit(this.token);
  //  this.cdRef.detectChanges();
  //}

  constructor(private cdRef: ChangeDetectorRef, private sanitizer: DomSanitizer,
    private FormService: formService, private ePayService: ePayService) {
  }

  //Get the iframe url
  ngOnInit() {
    //if (this.ePayService) {
    //  this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.ePayService.iFrame());
    //}
  }

  get EPayService(): ePayService {
    return this.FormService.EPayService;
  }
}
